// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2s5_A","consentsList":"PatientConsents_consentsList__13Xfo","consentsListEmpty":"PatientConsents_consentsListEmpty__2pw56"};